import React, { useEffect, useState, useRef } from "react";
import "./css/Webshop.css";
import { useNavigate } from "react-router-dom";

import OrderBoxJsx from "./OrderBoxJsx";
import { supabase } from "../../supabaseClient";
import ToHomeBtn from "../Shared/ToHomepageBtn";

import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

const WebshoppWithPayPal = () => {
  const [boxQuantity, setBoxQuantity] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [deliveryName, setDeliveryName] = useState("");
  const [deliveryAddress, setDeliveryAddress] = useState("");
  const [postNumber, setPostNumber] = useState("");
  const [city, setCity] = useState("");
  const [county, setCounty] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [isTicked, setIsTicked] = useState(false);
  const [latestOrderDetailsFromDb, setLatestOrderDetailsFromDb] =
    useState(null);
  const [addressMode, setAddressMode] = useState("same");
  const [multipleAddresses, setMultipleAddresses] = useState([]);
  const price = 1300;
  const navigate = useNavigate();
  const savedOverViewDataBeforeBoxesAreCleaned = useRef(null);

  useEffect(() => {
    if (addressMode === "multiple") {

      setMultipleAddresses(
        Array.from({ length: boxQuantity }, () => ({
          phoneNumber: "",
          deliveryName: "",
          deliveryAddress: "",
          postNumber: "",
          city: "",
          county: "",
        }))
      );
    }
  }, [addressMode, boxQuantity]);

  const puttingAddressValueInEmptyAddressArrays = (index, field, value) => {
    if (addressMode === "same") {
      if (field === "phoneNumber") setPhoneNumber(value);
      if (field === "deliveryName") setDeliveryName(value);
      if (field === "deliveryAddress") setDeliveryAddress(value);
      if (field === "postNumber") setPostNumber(value);
      if (field === "city") setCity(value);
      if (field === "county") setCounty(value);
      //ALL THESE WILL GO TO THE USUAL SET OF USESTATE INDIVIUDALLY LIKE IFREBASE
    } else {
      const updatedAddresses = [...multipleAddresses]; //copying the structure of multiple address from useEffect
      updatedAddresses[index][field] = value; //update specific field, for specifix i or box with the specific value it provides
      //buka box yang ke index, cari kolom field di box itu yang udah di kasih ...preparingMultipleAddress,
      //terus sama dengan itu ya kasih nilainya sama value yang ada.
      setMultipleAddresses(updatedAddresses);
    }
  };


  const showBoxOverview = () => {
    //somewhere around here, the box Qantity will be inside the latestOrderDetailsFromDb
    if (
      boxQuantity > 0 &&
      (addressMode === "same"
        ? phoneNumber &&
        deliveryName &&
        deliveryAddress &&
        postNumber &&
        city &&
        county
        : multipleAddresses.every(
          (addr) =>
            addr.phoneNumber &&
            addr.deliveryName &&
            addr.deliveryAddress &&
            addr.postNumber &&
            addr.city &&
            addr.county
        )) &&
      isTicked &&
      paymentMethod
    ) {
      const overviewData = {
        quantity: boxQuantity,
        deliveryDetails:
          addressMode === "same"
            ? {
              phoneNumber,
              deliveryName,
              deliveryAddress,
              postNumber,
              city,
              county,
            }
            : multipleAddresses,
        paymentMethod,
        fixedPrice: boxQuantity * price,
        statusOfPayment: "Pending",
        agreedToTerms: isTicked,
      };
      setLatestOrderDetailsFromDb(overviewData);
      savedOverViewDataBeforeBoxesAreCleaned.current = overviewData;
      cleanAllTheBox();

    } else {
      alert("Fylla i alla fälten");
    }
  };

  const pay = async (subscriptionID) => {
    const { data: userFromSupabase, error } = await supabase.auth.getUser();

    if (error || !userFromSupabase) {
      console.error("Error retrieving user:", error);
      alert("There is no user logged in, please log in");
      return;
    }

    const userId = userFromSupabase.user.id;
    console.log(userId);

    try {
      const orderDetails = savedOverViewDataBeforeBoxesAreCleaned.current;
      if (!orderDetails) {
        alert("No order details are found");
        return;
      }
      const boxesPayload = [];
      for (let i = 1; i <= orderDetails.quantity; i++) {
        boxesPayload.push({
          user_id: userId,
          expiration_date: new Date(
            new Date().setFullYear(new Date().getFullYear() + 1)
          )
            .toISOString()
            .split("T")[0],
        
        });
      }

      const { data: boxesData, error: boxesError } = await supabase
        //this right here means its already a big data
        .from("boxes")
        .insert(boxesPayload)
        //inser and select runs together
        .select("id"); //preparing to take the ones thats been made to be dissected in orders

      if (boxesError) {
        console.error("Error inserting boxes:", boxesError);
        alert("Error creating boxes: " + boxesError.message);
        return;
      }

      const orderPayloads = boxesData.map((box, index) => ({ //could as well be (b, i)
        user_id: userId,
        box_id: box.id,
        agreedToTerms: orderDetails.agreedToTerms,
        orderStatus: true,
        paymentMethod: orderDetails.paymentMethod,
        deliveryName:
          addressMode === "same"
            ? orderDetails.deliveryDetails.deliveryName
            : orderDetails.deliveryDetails[index]?.deliveryName,
        deliveryAddress:
          addressMode === "same"
            ? orderDetails.deliveryDetails.deliveryAddress
            : orderDetails.deliveryDetails[index]?.deliveryAddress,
        phoneNumber:
          addressMode === "same"
            ? orderDetails.deliveryDetails.phoneNumber
            : orderDetails.deliveryDetails[index]?.phoneNumber,
        paypalSubscriptionId: "" + subscriptionID
      }));

      const { data: orderData, error: orderError } = await supabase
        .from("orders")
        .insert(orderPayloads)
        .select("*");

      if (orderError) {
        console.error("Error inserting orders:", orderError);
        alert("Error creating orders: " + orderError.message);
        return;
      }
      console.log("you got em")
      console.log("Inserted orders:", orderData);

      alert(
        "Your orders are now received, and we will start working with the menu!"
      );
    } catch (error) {
      console.error("Unexpected error:", error);
      alert("Unexpected error: " + error.message);
    }
  };

  const cleanAllTheBox = () => {
    setBoxQuantity("");
    setPhoneNumber("");
    setDeliveryName("");
    setDeliveryAddress("");
    setPostNumber("");
    setCity("");
    setCounty("");
    setMultipleAddresses([]);
    setPaymentMethod("");
    setIsTicked(false);
  };
  return (
    <div className="container">
      <ToHomeBtn />
      <section className="section">
        <h2>Produktvalsektion</h2>
        <div className="centerit">
          <div className="box-container">
            <div className="box">
              <h3>Beställningar</h3>
              <p>Vi leverar inom 5 arbetsdagar</p>
              <form>
                <label htmlFor="box-quantity">
                  Antal lådor med obligatoriskt 1-års apprenuemration
                </label>
                <input
                  type="number"
                  placeholder="Antal boxar"
                  value={boxQuantity}
                  onChange={(e) => setBoxQuantity(e.target.value)}
                />
                <div className="address-mode-group">
                  <button
                    type="button"
                    className="address-mode-btn"
                    onClick={() => setAddressMode("same")}
                  >
                    Samma Adress
                  </button>
                  <button
                    type="button"
                    className="address-mode-btn"
                    onClick={() => setAddressMode("multiple")}
                  >
                    Olika Adress
                  </button>
                </div>
                {addressMode === "same" ? (
                  <OrderBoxJsx
                    phoneNumber={phoneNumber}
                    setPhoneNumber={(value) =>
                      puttingAddressValueInEmptyAddressArrays(
                        null,
                        "phoneNumber",
                        value
                      )
                    }
                    deliveryName={deliveryName}
                    setDeliveryName={(value) =>
                      puttingAddressValueInEmptyAddressArrays(
                        null,
                        "deliveryName",
                        value
                      )
                    }
                    deliveryAddress={deliveryAddress}
                    setDeliveryAddress={(value) =>
                      puttingAddressValueInEmptyAddressArrays(
                        null,
                        "deliveryAddress",
                        value
                      )
                    }
                    postNumber={postNumber}
                    setPostNumber={(value) =>
                      puttingAddressValueInEmptyAddressArrays(
                        null,
                        "postNumber",
                        value
                      )
                    }
                    city={city}
                    setCity={(value) =>
                      puttingAddressValueInEmptyAddressArrays(
                        null,
                        "city",
                        value
                      )
                    }
                    county={county}
                    setCounty={(value) =>
                      puttingAddressValueInEmptyAddressArrays(
                        null,
                        "county",
                        value
                      )
                    }
                  />
                ) : (
                  multipleAddresses.map((address, index) => (
                    <div>
                      <h4>Box {index + 1}</h4>
                      <OrderBoxJsx
                        key={index}
                        phoneNumber={address.phoneNumber}
                        setPhoneNumber={(value) =>
                          puttingAddressValueInEmptyAddressArrays(
                            index,
                            "phoneNumber",
                            value
                          )
                        }
                        deliveryName={address.deliveryName}
                        setDeliveryName={(value) =>
                          puttingAddressValueInEmptyAddressArrays(
                            index,
                            "deliveryName",
                            value
                          )
                        }
                        deliveryAddress={address.deliveryAddress}
                        setDeliveryAddress={(value) =>
                          puttingAddressValueInEmptyAddressArrays(
                            index,
                            "deliveryAddress",
                            value
                          )
                        }
                        postNumber={address.postNumber}
                        setPostNumber={(value) =>
                          puttingAddressValueInEmptyAddressArrays(
                            index,
                            "postNumber",
                            value
                          )
                        }
                        city={address.city}
                        setCity={(value) =>
                          puttingAddressValueInEmptyAddressArrays(
                            index,
                            "city",
                            value
                          )
                        }
                        county={address.county}
                        setCounty={(value) =>
                          puttingAddressValueInEmptyAddressArrays(
                            index,
                            "county",
                            value
                          )
                        }
                      />
                    </div>
                  ))
                )}

                <label htmlFor="payment-method">Betalningsmetod</label>
                <select
                  id="payment-method"
                  onChange={(e) => setPaymentMethod(e.target.value)}
                >
                  <option> </option>
                  <option value="visa">Visa</option>
                  <option value="mastercard">Mastercard</option>
                  <option value="paypal">Paypal Account</option>
                </select>

                <div className="terms">
                  <input
                    type="checkbox"
                    id="accept-terms"
                    onChange={(e) => setIsTicked(e.target.checked)}
                  />
                  <label htmlFor="accept-terms">Jag accepterar villkoren</label>
                  <a href="google.com" className="link">
                    Läsa villkoren
                  </a>
                </div>
              </form>
              <button onClick={showBoxOverview} className="btn">
                NÄSTA
              </button>
            </div>
            <div className="box">
              <h3>Din senaste beställning</h3>
              {latestOrderDetailsFromDb ? (
                <div>
                  <p>
                    <strong>Antal lådor:</strong>{" "}
                    {latestOrderDetailsFromDb.quantity}
                  </p>
                  {addressMode === "same" ? (
                    <>
                      <p>
                        <strong>Namn:</strong>{" "}
                        {latestOrderDetailsFromDb.deliveryDetails.deliveryName}
                      </p>
                      <p>
                        <strong>Adress:</strong>{" "}
                        {
                          latestOrderDetailsFromDb.deliveryDetails
                            .deliveryAddress
                        }
                        , {latestOrderDetailsFromDb.deliveryDetails.city},{" "}
                        {latestOrderDetailsFromDb.deliveryDetails.postNumber} -{" "}
                        {latestOrderDetailsFromDb.deliveryDetails.county}
                      </p>
                      <p>
                        <strong>Telefonnummer:</strong>{" "}
                        {latestOrderDetailsFromDb.deliveryDetails.phoneNumber}
                      </p>
                    </>
                  ) : (
                    latestOrderDetailsFromDb.deliveryDetails.map(
                      (addr, index) => (
                        <div key={index}>
                          <h4>Box {index + 1}:</h4>
                          <p>Namn:{addr.deliveryName}</p>
                          <p>
                            Adress:{addr.deliveryAddress}, {addr.city},{" "}
                            {addr.postNumber} - {addr.county}
                          </p>
                          <p>Telefonnummer:{addr.phoneNumber}</p>
                        </div>
                      )
                    )
                  )}
                  <p>
                    <strong>Pris:</strong> {latestOrderDetailsFromDb.fixedPrice}
                  </p>
                  <p>
                    <strong>Status:</strong>{" "}
                    {latestOrderDetailsFromDb.statusOfPayment}
                  </p>
                  <PayPalScriptProvider options={{ "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID, vault: true, intent: "subscription" }}>
                    <PayPalButtons
                      style={{ shape: "rect", color: "gold", layout: "vertical", label: "subscribe" }}
                      createSubscription={(data, actions) => {
                        return actions.subscription.create({
                          plan_id: process.env.REACT_APP_PRODUCT_PAYPAL_ARRAY_ID.split(",")[latestOrderDetailsFromDb.quantity]
                        })
                      }}
                      onApprove={async (data, actions) => {
                        alert(`We got em: ${data.subscriptionID}`);
                        console.log(JSON.stringify(data, null, 2))
                        await pay(data.subscriptionID);
                      }}
                    ></PayPalButtons>
                  </PayPalScriptProvider>
                </div>
              ) : (
                <p>Inga beställningar hittades</p>
              )}

            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WebshoppWithPayPal;

/* 
                  <PayPalScriptProvider options={{"client-id": process.env.REACT_APP_PAYPAL_APP_CLIENT_ID_SANDBOX_MODE, vault: true, intent: "subscription"}}>
                    <PayPalButtons 
                    style={{ shape: "rect", color: "gold", layout: "vertical", label: "subscribe" }}
                      createSubscription={(data, actions) =>{
                        return actions.subscription.create({
                          plan_id: "P-23Y02624LW376705HM6ROBDI"})
                      }}
                      onApprove={async (data, actions) =>{
                        console.log(Subscription ID: ${data.subscriptionID})
                        console.log(Subscription successful! all data: ${data})
                        alert(Subscription successful! Subscription ID: ${data.subscriptionID});
                        await pay();
                      }}
                    ></PayPalButtons>
                  </PayPalScriptProvider>
                  */

/*
                  <PayPalScriptProvider options={{"client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID, vault: true, intent: "subscription"}}>
  <PayPalButtons 
  style={{ shape: "rect", color: "gold", layout: "vertical", label: "subscribe" }}
    createSubscription={(data, actions) =>{
      return actions.subscription.create({
        plan_id: process.env.REACT_APP_PRODUCT_PAYPAL_ARRAY_ID.split(",")[latestOrderDetailsFromDb.quantity]
      })
    }}
    onApprove={async (data, actions) =>{
      alert(Subscription successful! Subscription ID: ${data.subscriptionID});
      await pay();
    }}
  ></PayPalButtons>
</PayPalScriptProvider>*/

